module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACpSURBVHgB7ZQhDsJAFETnFwSy3AAcB0BguAsK6liqmiIKqmCgOEBxFBIMgjvAEXqCHX4gJAS5WUX2uS/m5Y8ZgTJO8wIUI2AMBwipIfZ03JQzmaTzLUgDD1CwbJIYiR5C291XqwccSEzWoUR3IabRp6ar7CcbR/BMEAZhEP6J8DWOeE8QHPnK1pKYfKHDWMALdte4XS/n/mDYVmlPh7YFB6ifadX1oSqzJ7r9N0zXIG18AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-cur.png
// module id = tFvf
// module chunks = 36